module.exports = __webpack_public_path__ + "img/recordsIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/recordsIcon.png
// module id = 9CPm
// module chunks = 0